import { Link } from "react-router";

import { useSessionDevices } from "@/shared/domain/sessions/hooks";
import {
  RotateCw as RotateCwIcon,
  TriangleAlert as TriangleAlertIcon,
} from "@/shared/foundation/icons";
import { RobotoButton, Spinner } from "@/shared/foundation/primitives";
import { Goto } from "@/shared/navigation";

import styles from "./SessionDevices.module.css";

/**
 * The value of the session's Devices property: each attached device as a link
 * to its device page, "—" when there are none, or an error with a retry.
 */
export function SessionDevices({ sessionId }: { sessionId: string }) {
  const {
    data: deviceIds,
    error,
    isFetching,
    refetch,
  } = useSessionDevices(sessionId);

  if (error) {
    return (
      <span className={styles.error}>
        <TriangleAlertIcon className={styles.errorIcon} aria-hidden />
        Failed to load devices
        <RobotoButton
          variant="ghost"
          size="sm"
          icon={<RotateCwIcon />}
          aria-label="Retry loading devices"
          loading={isFetching}
          onClick={() => void refetch()}
        />
      </span>
    );
  }
  if (deviceIds === undefined) {
    return <Spinner />;
  }
  if (deviceIds.length === 0) {
    return "—";
  }
  return (
    <ul className={styles.deviceList}>
      {deviceIds.map((deviceId) => (
        <li key={deviceId}>
          <Link className={styles.link} to={Goto.createDeviceRoute(deviceId)}>
            {deviceId}
          </Link>
        </li>
      ))}
    </ul>
  );
}
